export class IconType {
    public static readonly DANGER = 'fa fa-exclamation-circle';
    public static readonly WARNING = 'fa fa-exclamation-triangle';
    public static readonly INFO = 'fa fa-info';
    public static readonly SUCCESS = 'fa fa-check-circle';
}
